<style scoped>
.error-message {
    color: #e53e3e;
    font-size: 14px;
    margin-top: 5px;
    margin-bottom: 10px;
}

.processing {
    opacity: 0.7;
    cursor: not-allowed;
}
</style>
<template>
<div class="">
    <!-- Header Section -->
    <section class="simple-nav">
        <div class="simplenav_wrap">
            <div class="simplenav_flex">
                <div class="nav-left-div">
                    <a href="#" class="link-block w-inline-block"><img src="@/assets/images/OhMyMeds_Logo-Update.svg" loading="lazy" alt="" class="image-545"></a>
                    <div class="nav-menu-links-div desk">
                        <div class="div-block-1129"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="nav-shadow"></div>
        <div class="mobile-nav-div">
            <div data-animation="default" data-collapse="medium" data-duration="400" data-easing="ease" data-easing2="ease" role="banner" class="navbar-mobile w-nav">
                <a href="#" class="brand home w-nav-brand"><img src="@/assets/images/OhMyMeds_Logo-Update.svg" loading="lazy" alt="" class="image-551"></a>
                <div class="w-nav-overlay" data-wf-ignore="" id="w-nav-overlay-0"></div>
            </div>
            <div class="div-block-1958"></div>
        </div>
    </section>

    <div id="mainheader"></div>

    <div class="form-section" v-if="pageStep==1">
        <div class="enroll-div-wrap">
            <!-- Step 1: Welcome and Terms Agreement -->
            <div class="enroll-slide-1" v-if="active_el === 1">
                <div class="form-block w-form">
                    <form id="email-form-2" @submit.prevent="handleSubmit">
                        <div class="enroll-slide-1-div-3">
                            <img sizes="(max-width: 641px) 100vw, 641px" srcset="@/assets/images/stepsimage_teledoc_nS-p-500.png 500w, @/assets/images/stepsimage_teledoc_nS.png 641w" alt="" src="@/assets/images/stepsimage_teledoc_nS.png" loading="lazy" class="enroll-top-image">
                            <div class="enroll-header-2">Welcome to OHMY! Meds</div>
                            <p class="enroll-sub-2">The following questions will will be used by a board certified physician licensed in your state to help create a treatment plan for you. <strong>Please answer all questions accurately.</strong></p>
                            <div class="enroll-3-things-div">
                                <div class="enroll-bullet-div"><img loading="lazy" src="@/assets/images/icon_ohmy_meds.png" alt="" class="enroll-bullet-image">
                                    <div class="enroll-bullet-text">All Dosages Same Price</div>
                                </div>
                                <div class="enroll-bullet-div"><img loading="lazy" src="@/assets/images/icon_ohmy_doc.png" alt="" class="enroll-bullet-image">
                                    <div class="enroll-bullet-text">Board-certified physicians</div>
                                </div>
                                <div class="enroll-bullet-div"><img loading="lazy" src="@/assets/images/icon_ohmy_pharma.png" alt="" class="enroll-bullet-image">
                                    <div class="enroll-bullet-text">503A Pharmacy Partners</div>
                                </div>
                            </div>
                            <div class="enroll-disclaimer-div _1st">
                                <label class="w-checkbox enroll-checkbox-field">
                                    <input type="checkbox" v-model="people.agreed_to_terms" name="checkbox-3" id="checkbox-3" data-name="Checkbox 3" class="w-checkbox-input enroll-checkbox top">
                                    <span class="enroll-checkbox-label w-form-label" for="checkbox-3">I Agree to OhMy! Meds&#x27; <a href="https://www.ohmymeds.com/terms" target="_blank" class="enroll-checkbox-link">Terms</a>, <a href="https://www.ohmymeds.com/privacy" target="_blank" class="enroll-checkbox-link">Privacy Policy</a> and consent to <a href="https://www.ohmymeds.com/telehealth" target="_blank" class="enroll-checkbox-link">Telehealth</a></span>
                                </label>
                                <div v-if="formErrors.terms" class="error-message">{{ formErrors.terms }}</div>
                            </div>
                            <div class="enroll-form-button-div">
                                <input type="submit" data-wait="Please wait..." class="enroll-form-submit-button top w-button" value="Start my FREE visit ->">
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            <!-- Step 2: State Selection -->
            <div class="enroll-slide-7" v-if="active_el === 2">
                <div class="question-category">
                    <div class="enroll-form-header-text">LET&#x27;S START WITH THE BASICS</div>
                </div>
                <div class="enroll-form-block update w-form">
                    <form id="email-form" @submit.prevent="handleSubmit" class="enroll-form update">
                        <h1 class="enroll-form-question-text">Let&#x27;s make sure we are licensed in your state</h1>
                        <select id="State-4" v-model="people.state" name="State-4" data-name="State 4" required class="select-field-3 form update w-select">
                            <option value="">State...</option>
                            <option v-for="(value, key) in allState" :value="value" :key="value">{{ key }}</option>
                        </select>
                        <div v-if="formErrors.state" class="error-message">{{ formErrors.state }}</div>
                        <input type="submit" data-wait="Please wait..." class="enroll-form-submit-button w-button" value="Next ->">
                    </form>
                </div>
                <div class="enroll-form-back-link-div">
                    <a href="#" @click.prevent="goBack" class="enroll-form-back-link w-inline-block">
                        <div class="enroll-form-back-text">&lt; Go Back</div>
                    </a>
                </div>
            </div>

            <!-- Step 3: Name -->
            <div class="enroll-slide-7" v-if="active_el === 3">
                <div class="question-category">
                    <div class="enroll-form-header-text">LET&#x27;S START WITH THE BASICS</div>
                </div>
                <div class="enroll-form-block update w-form">
                    <form id="email-form" @submit.prevent="handleSubmit" class="enroll-form update">
                        <h1 class="enroll-form-question-text smaller a">Who do I have the pleasure of talking to?</h1>
                        <div class="enroll-form-field-wrap-div update">
                            <input class="text-field-59 update w-input" maxlength="256" v-model="people.first_name" name="name-2" data-name="Name 2" placeholder="First Name" type="text" id="name-2">
                            <input class="text-field-59 update w-input" maxlength="256" v-model="people.last_name" name="Last-name-2" data-name="Last Name 2" placeholder="Last Name" type="text" id="Last-name-2" required>
                        </div>
                        <div v-if="formErrors.name" class="error-message">{{ formErrors.name }}</div>
                        <input type="submit" data-wait="Please wait..." class="enroll-form-submit-button w-button" value="Next ->">
                    </form>
                </div>
                <div class="enroll-form-back-link-div">
                    <a href="#" @click.prevent="goBack" class="enroll-form-back-link w-inline-block">
                        <div class="enroll-form-back-text">&lt; Go Back</div>
                    </a>
                </div>
            </div>

            <!-- Step 4: Gender -->
            <div class="enroll-slide-7" v-if="active_el === 4">
                <div class="question-category">
                    <div class="enroll-form-header-text">LET&#x27;S START WITH THE BASICS</div>
                </div>
                <div class="enroll-form-block update w-form">
                    <form id="email-form" @submit.prevent="handleSubmit" class="enroll-form update">
                        <h1 class="enroll-form-question-text smaller">What was your gender at birth?</h1>
                        <div class="gender-div">
                            <label class="w-checkbox checkbox-field-22 male" @click="updateGender('Male')">
                                <input type="checkbox" name="checkbox-4" id="checkbox-4" data-name="Checkbox 4" class="w-checkbox-input enroll-checkbox">
                                <span class="checkbox-label-15 w-form-label" for="checkbox-4">Male</span>
                            </label>
                            <label class="w-checkbox checkbox-field-22 female" @click="updateGender('Female')">
                                <input type="checkbox" name="checkbox-4" id="checkbox-4" data-name="Checkbox 4" class="w-checkbox-input enroll-checkbox">
                                <span class="checkbox-label-15 w-form-label" for="checkbox-4">Female</span>
                            </label>
                        </div>
                        <div v-if="formErrors.gender" class="error-message">{{ formErrors.gender }}</div>
                        <input type="submit" data-wait="Please wait..." class="enroll-form-submit-button w-button" value="Next ->">
                    </form>
                </div>
                <div class="enroll-form-back-link-div">
                    <a href="#" @click.prevent="goBack" class="enroll-form-back-link w-inline-block">
                        <div class="enroll-form-back-text">&lt; Go Back</div>
                    </a>
                </div>
            </div>

            <!-- Step 5: Email -->
            <div class="enroll-slide-7" v-if="active_el === 5">
                <div class="question-category">
                    <div class="enroll-form-header-text">LET&#x27;S START WITH THE BASICS</div>
                </div>
                <div class="enroll-form-block update w-form">
                    <form id="email-form" @submit.prevent="handleSubmit" class="enroll-form update">
                        <h1 class="enroll-form-question-text smaller">Please enter your email</h1>
                        <input class="text-field-59 email form update w-input" maxlength="256" v-model="people.email" name="Email-2" data-name="Email 2" placeholder="Enter your email" type="email" autocomplete="email" id="Email-2" required>
                        <div v-if="formErrors.email" class="error-message">{{ formErrors.email }}</div>
                        <div class="enroll-disclaimer-div form">
                            <label class="w-checkbox enroll-checkbox-field form">
                                <input type="checkbox" v-model="people.agreed_to_email" name="checkbox-3" id="checkbox-3" data-name="Checkbox 3" class="w-checkbox-input enroll-checkbox">
                                <span class="enroll-checkbox-label form w-form-label" for="checkbox-3">I agree to receive doctor correspondence, transactional and/or marketing messaging from Oh My! Meds to the email address that I provided above.</span>
                            </label>
                            <div v-if="formErrors.emailConsent" class="error-message">{{ formErrors.emailConsent }}</div>
                        </div>
                        
                        <input type="submit" data-wait="Please wait..." class="enroll-form-submit-button w-button" value="Next ->">
                    </form>
                </div>
                <div class="enroll-form-back-link-div">
                    <a href="#" @click.prevent="goBack" class="enroll-form-back-link w-inline-block">
                        <div class="enroll-form-back-text">&lt; Go Back</div>
                    </a>
                </div>
            </div>

            <!-- Step 6: Phone Number -->
            <div class="enroll-slide-7" v-if="active_el === 6">
                <div class="question-category">
                    <div class="enroll-form-header-text">LET&#x27;S START WITH THE BASICS</div>
                </div>
                <div class="enroll-form-block update w-form">
                    <form id="email-form" @submit.prevent="handleSubmit" class="enroll-form update">
                        <h1 class="enroll-form-question-text smaller">Please enter your mobile number</h1>
                        <div class="phone-entry-div update">
                            <input class="phone-number-field-3 _1 form update w-input" maxlength="3" inputmode="tel" autocomplete="tel" pattern="[0-9]*" v-model="people.phone_parts.areaCode" @input="handlePhoneInput($event, 'areaCode')" ref="areaCode" placeholder="(000)" type="number" required>
                            <div class="text-block-1354">-</div>
                            <input class="phone-number-field-3 form update w-input" maxlength="3" v-model="people.phone_parts.prefix" @input="handlePhoneInput($event, 'prefix')" ref="prefix" pattern="[0-9]*" placeholder="000" type="number" required>
                            <div class="text-block-1354">-</div>
                            <input class="phone-number-field-3 _2 form update w-input" maxlength="4" v-model="people.phone_parts.line" @input="handlePhoneInput($event, 'line')" ref="line" pattern="[0-9]*" placeholder="0000" type="number" required>
                        </div>
                        <div v-if="formErrors.phone" class="error-message">{{ formErrors.phone }}</div>
                        <input type="hidden" name="xxTrustedFormCertUrl" id="xxTrustedFormCertUrl_0" ref="trustedFormUrl" value="">
                        <input type="submit" data-wait="Please wait..." class="enroll-form-submit-button w-button" value="Next ->">
                    </form>
                </div>
                <div class="enroll-form-back-link-div">
                    <a href="#" @click.prevent="goBack" class="enroll-form-back-link w-inline-block">
                        <div class="enroll-form-back-text">&lt; Go Back</div>
                    </a>
                </div>
            </div>

            <!-- Step 7: Height and Weight -->
            <div class="enroll-slide-6" v-if="active_el === 7">
                <div class="question-category">
                    <div class="enroll-form-header-text">LET&#x27;S START WITH THE BASICS</div>
                </div>
                <h1 class="enroll-form-question-text">What is your height and weight?</h1>
                <p class="enroll-form-question-sub">We&#x27;ll use this to determine your Body mass Index (BMI) for diagnosis. remember, BMI is a measure of size - not health</p>
                <div class="enroll-form-block b w-form">
                    <form id="email-form" @submit.prevent="handleSubmit" class="enroll-form b">
                        <div class="enroll-form-field-wrap-div b _2">
                            <div class="enroll-form-input-div mobile-entry form _2 height top">
                                <input class="enroll-form-text-field height w-input" maxlength="256" pattern="[0-9]*" v-model="people.height.foot" name="feet" data-name="Feet" placeholder="Feet" type="number" id="feet" required>
                                <div class="field-label-text">ft.</div>
                                <input class="enroll-form-text-field height update w-input" maxlength="256" pattern="[0-9]*" v-model="people.height.inches" name="inches" data-name="Inches" placeholder="Inches" type="number" id="inches" required>
                                <div class="field-label-text last">in.</div>
                            </div>
                            <div class="enroll-form-input-div mobile-entry form _2 weight">
                                <input class="enroll-form-text-field weight w-input" maxlength="256" pattern="[0-9]*" v-model="people.weight" name="weight-2" data-name="Weight 2" placeholder="Weight in pounds" type="number" id="weight-2" required>
                                <div class="field-label-text weight">lbs.</div>
                            </div>
                        </div>
                        <div v-if="formErrors.height || formErrors.weight" class="error-message">
                            {{ formErrors.height || formErrors.weight }}
                        </div>
                        <input type="submit" data-wait="Please wait..." class="enroll-form-submit-button w-button" value="Next ->">
                    </form>
                </div>
                <div class="enroll-form-back-link-div">
                    <a href="#" @click.prevent="goBack" class="enroll-form-back-link w-inline-block">
                        <div class="enroll-form-back-text">&lt; Go Back</div>
                    </a>
                </div>
            </div>

            <!-- Step 8: Date of Birth -->
            <div class="question-container" v-if="active_el === 8">
                <div class="question-category">
                    <div class="enroll-form-header-text">LET&#x27;S START WITH THE BASICS</div>
                </div>
                <div class="question-div-2">
                    <div class="text-block-1383">What is your date of birth?</div>
                    <div class="form-subs">Based on your date of birth our doctors can prescribe the proper prescription.</div>
                    <div class="felix-form-block w-form">
                        <form id="email-form" @submit.prevent="validateDOBAndContinue">
                            <div class="div-block-2072 mobile-entry form _2 birth">
                                <select id="birth-month-2" v-model="people.dob.mm" name="birth-month-2" data-name="Birth Month 2" class="select-field-13 felix w-select">
                                    <option value="">Month</option>
                                    <option value="01">January</option>
                                    <option value="02">February</option>
                                    <option value="03">March</option>
                                    <option value="04">April</option>
                                    <option value="05">May</option>
                                    <option value="06">June</option>
                                    <option value="07">July</option>
                                    <option value="08">August</option>
                                    <option value="09">September</option>
                                    <option value="10">October</option>
                                    <option value="11">November</option>
                                    <option value="12">December</option>
                                </select>
                                <div class="text-block-1380">-</div>
                                <input class="phone-number-field-3 form birth felix w-input" maxlength="2" max="31" min="1" pattern="[0-9]*" v-model="people.dob.dd" name="birth-day-2" data-name="Birth Day 2" placeholder="Day" type="number" id="birth-day-2" required>
                                <div class="text-block-1380">-</div>
                                <input class="phone-number-field-3 _2 form birth felix w-input" max="2024" min="1935" pattern="[0-9]*" v-model="people.dob.yyyy" name="birth-year-2" data-name="Birth Year 2" placeholder="Year" type="number" id="birth-year-2" required>
                            </div>
                            <div v-if="formErrors.dob" class="error-message">{{ formErrors.dob }}</div>
                            <input type="submit" data-wait="Please wait..." class="form-button w-button" value="Next ->">
                        </form>
                    </div>
                </div>
            </div>

            <!-- Step 9: Desired Weight (Final Step) -->
            <div class="enroll-slide-6" v-if="active_el === 9">
                <div class="question-category">
                    <div class="enroll-form-header-text">GOALS</div>
                </div>
                <h1 class="enroll-form-question-text">What is your <span class="text-span-309">desired weight</span>?</h1>
                <div class="enroll-form-block b update w-form">
                    <form id="email-form" @submit.prevent="finalSubmit" class="enroll-form b">
                        <div class="enroll-form-field-wrap-div b">
                            <div class="enroll-form-input-div mobile-entry form _2 weight pad">
                                <input class="enroll-form-text-field weight w-input" maxlength="256" pattern="[0-9]*" v-model="people.desired_weight" name="Goal-Weight" data-name="Goal Weight" placeholder="What is your goal weight in pounds?" type="number" id="Goal-Weight" required>
                                <div class="field-label-text weight">lbs.</div>
                            </div>
                        </div>
                        <div v-if="formErrors.desiredWeight" class="error-message">{{ formErrors.desiredWeight }}</div>
                        <div v-if="formErrors.submission" class="error-message">{{ formErrors.submission }}</div>
                        <input type="submit" data-wait="Please wait..." :class="{'processing': isSubmitting}" class="enroll-form-submit-button w-button" :value="isSubmitting ? 'Processing...' : 'Start my FREE visit ->'">
                    </form>
                </div>
                <div class="enroll-form-back-link-div">
                    <a href="#" @click.prevent="goBack" class="enroll-form-back-link w-inline-block">
                        <div class="enroll-form-back-text">&lt; Go Back</div>
                    </a>
                </div>
            </div>
        </div>
    </div>
    <div class="form-section" v-if="pageStep==2">
        <div class="questions-div">
            <div class="question-container">
                <div class="question-category">
                    <div class="enroll-form-header-text">CONGRATULATIONS</div>
                </div>
                <div class="question-div-2">
                    <div class="div-block-2061 end">
                        <div class="text-block-1374">You Qualify, {{people.first_name}}!</div>
                    </div>
                    <div class="text-block-1383 end bold">You are the perfect candidate for our Weight Loss Program.</div>
                    <div class="form-subs end break">You could lose up to 32 pounds in the next 90 days if you follow the Oh My! Meds weight loss program</div>
                    <div class="checks-div end">
                        <div class="bullet-div end"><img loading="lazy" src="@/assets/images/icon_check-black2.svg" alt="" class="image-539">
                            <div class="text-block-1386">Lose weight for <strong>1/4 the price </strong>of drugs like Ozempic &amp; Mounjaro.</div>
                        </div>
                        <div class="bullet-div end"><img loading="lazy" src="@/assets/images/icon_check-black2.svg" alt="" class="image-539">
                            <div class="text-block-1386">Meet with US-based doctor <strong>over quick video call.</strong></div>
                        </div>
                        <div class="bullet-div end"><img loading="lazy" src="@/assets/images/icon_check-black2.svg" alt="" class="image-539">
                            <div class="text-block-1386">Get your medication deliver to your door <strong>in 3-5 days.</strong></div>
                        </div>
                    </div>
                    <div class="report-summary-div">
                        <div class="div-block-2052">
                            <div class="div-block-2058">
                                <div class="div-block-2046">
                                    <div class="div-block-2043">
                                        <div class="text-block-1373">{{people.first_name}}, This is the start of your weight loss journey</div>
                                    </div>
                                    <div class="div-block-2063">
                                        <div class="div-block-2073">
                                            <div class="text-block-1368">Your Current Weight is</div>
                                            <div class="text-block-1376">{{people.weight}} <span class="text-span-318">lbs</span></div>
                                        </div>
                                        <div class="div-block-2073">
                                            <div class="text-block-1368">Your Target Weight is</div>
                                            <div class="text-block-1376">{{people.desired_weight}} <span class="text-span-318">lbs</span></div>
                                        </div>
                                    </div>
                                </div>

                                <div class="div-block-2054">
                                    <div class="table-header-2">Weight Loss Projections<br>for <strong>{{people.first_name}}</strong><br></div>
                                    <div class="div-block-2053">
                                        <div class="table-row-div-2 top">
                                            <div class="div-block-2057">
                                                <div class="text-block-1353 top">Program</div>
                                            </div>
                                            <div class="div-block-2060">
                                                <div class="text-block-1353 top">% Loss</div>
                                            </div>
                                            <div class="div-block-2078">
                                                <div class="text-block-1353 top">Weight Loss</div>
                                            </div>
                                            <div class="div-block-2062">
                                                <div class="text-block-1353 top">New Weight</div>
                                            </div>
                                        </div>
                                        <div class="table-row-div-2">
                                            <div class="div-block-2057">
                                                <div class="text-block-1353">Avg. Weight Loss on Semaglutide</div>
                                            </div>
                                            <div class="div-block-2060">
                                                <div class="text-block-1393">16%</div>
                                            </div>
                                            <div class="div-block-2078">
                                                <div class="text-block-1393">{{ (parseInt(people.weight) * 0.16).toFixed(0) }} <span class="text-span-321">lbs</span></div>
                                            </div>
                                            <div class="div-block-2062">
                                                <div class="text-block-1393">{{ (parseInt(people.weight) - (parseInt(people.weight) * 0.16)).toFixed(0) }} <span class="text-span-321">lbs</span></div>
                                            </div>
                                        </div>
                                        <div class="table-row-div-2">
                                            <div class="div-block-2057">
                                                <div class="text-block-1353">Avg. Weight Loss on Tirzepatide</div>
                                            </div>
                                            <div class="div-block-2060">
                                                <div class="text-block-1393">22%</div>
                                            </div>
                                            <div class="div-block-2078">
                                                <div class="text-block-1393">{{ (parseInt(people.weight) * 0.22).toFixed(0) }} <span class="text-span-321">lbs</span></div>
                                            </div>
                                            <div class="div-block-2062">
                                                <div class="text-block-1393">{{ (parseInt(people.weight) - (parseInt(people.weight) * 0.22)).toFixed(0) }} <span class="text-span-321">lbs</span></div>
                                            </div>
                                        </div>
                                        <div class="table-row-div-2">
                                            <div class="div-block-2057">
                                                <div class="text-block-1353">1 in 3 lose more on Semaglutide<br></div>
                                            </div>
                                            <div class="div-block-2060">
                                                <div class="text-block-1393">23%</div>
                                            </div>
                                            <div class="div-block-2078">
                                                <div class="text-block-1393">{{ (parseInt(people.weight) * 0.23).toFixed(0) }} <span class="text-span-321">lbs</span></div>
                                            </div>
                                            <div class="div-block-2062">
                                                <div class="text-block-1393">{{ (parseInt(people.weight) - (parseInt(people.weight) * 0.23)).toFixed(0) }} <span class="text-span-321">lbs</span></div>
                                            </div>
                                        </div>
                                        <div class="table-row-div-2">
                                            <div class="div-block-2057">
                                                <div class="text-block-1353">1 in 5 on Oh My! Meds' Program Lose</div>
                                            </div>
                                            <div class="div-block-2060">
                                                <div class="text-block-1393">31%</div>
                                            </div>
                                            <div class="div-block-2078">
                                                <div class="text-block-1393">{{ (parseInt(people.weight) * 0.31).toFixed(0) }} <span class="text-span-321">lbs</span></div>
                                            </div>
                                            <div class="div-block-2062">
                                                <div class="text-block-1393">{{ (parseInt(people.weight) - (parseInt(people.weight) * 0.22)).toFixed(0) }} <span class="text-span-321">lbs</span></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <router-link to="/select-med" class="button-132 finish w-button floating-cta-button">Start Your Weight Loss Journey <span class="text-span-313">-&gt;</span></router-link>
                </div>
            </div>
        </div>
    </div>
    <div style="height: 420px;"></div>
</div>
</template>

<script>
import state from "@/utils/state.json"
import {
    mapActions
} from 'vuex'

export default {
    name: 'OhMyMedsForm',
    data() {
        return {
            allState: state,
            baseUrl: process.env.VUE_APP_API_ENDPOINT,
            appName: process.env.VUE_APP_COMPANY,
            appMainWeb: process.env.VUE_APP_HOMEPAGE,
            active_el: 1,
            pageStep: 1,
            total_steps: 9,
            tempvalue: '',
            formErrors: {},
            isSubmitting: false,
            isLeadSubmitting: false,
            isLeadCaptured: false,
            leadData: null,
            people: {
                first_name: '',
                last_name: '',
                email: '',
                phone: '',
                phone_parts: {
                    areaCode: '',
                    prefix: '',
                    line: ''
                },
                heightInInches: '',
                height: {
                    foot: '',
                    inches: ''
                },
                weight: '',
                bmi: '',
                gender: '',
                agreed_to_text: "Yes",
                agreed_to_email: true,
                desired_weight: '',
                state: '',
                agreed_to_terms: true,
                form_step2_agree: true,
                dobMMDDYYYY: 'NA',
                source_web: 2,
                ip_address: '',
                tracking_session_id:'',
                user_agent:'',
                age: '',
                dob: {
                    mm: '',
                    dd: '',
                    yyyy: ''
                },
            }
        }
    },
    async mounted() {
        if (this.$route.query.sema) {
            await this.$store.dispatch('addSemaOffer', this.$route.query.sema);
        }
        if (this.$route.query.tir) {
            await this.$store.dispatch('addTirOffer', this.$route.query.tir);
        }
        this.getIpAddress();
    },
    watch: {
        active_el() {
            const el = document.getElementById('mainheader');
            if (el) {
                el.scrollIntoView({
                    behavior: 'smooth'
                }); // or 'auto' if you don't want smooth scrolling
            }
        }
    },
    computed: {
        isFormErrorEmpty() {
            return Object.keys(this.formErrors).length === 0;
        },
        isValidPhone() {
            const {
                areaCode,
                prefix,
                line
            } = this.people.phone_parts;
            // Check if all parts exist and are the correct length
            return (
                areaCode?.length === 3 &&
                prefix?.length === 3 &&
                line?.length === 4 &&
                /^\d+$/.test(areaCode) &&
                /^\d+$/.test(prefix) &&
                /^\d+$/.test(line)
            );
        },
        phoneNumber() {
            const {
                areaCode,
                prefix,
                line
            } = this.people.phone_parts;
            if (!this.isValidPhone) return '';
            return `${areaCode}${prefix}${line}`;
        },
        isValidEmail() {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(this.people.email);
        },
        calculatedBMI() {
            if (this.people.weight && this.people.heightInInches) {
                const heightInInches = parseFloat(this.people.heightInInches);
                const weightInPounds = parseFloat(this.people.weight);
                return (weightInPounds / (heightInInches * heightInInches)) * 703;
            }
            return null;
        }
    },
    methods: {
        ...mapActions([
            'setCartVisibility'
        ]),
        showChatWindow() {
            this.$root.$emit('toggle-chat');
        },
        async getIpAddress() {
            try {
                const response = await fetch('https://api.ipify.org?format=json');
                const data = await response.json();
                this.people.ip_address = data.ip;
                return data.ip;
            } catch (error) {
                console.error('Error getting IP:', error);
            }
        },
        goBack() {
            if (this.active_el > 1) {
                this.active_el--;
            }
        },
        isValidDate(month, day, year) {
            const date = new Date(year, month - 1, day);
            const today = new Date();

            // Check if the date is valid
            if (!(date instanceof Date) || isNaN(date) ||
                date.getMonth() !== month - 1 ||
                date.getDate() !== parseInt(day) ||
                date.getFullYear() !== parseInt(year)) {
                return false;
            }

            // Ensure the year is between 1924 and the current year
            const currentYear = today.getFullYear();
            if (year < 1924 || year > currentYear) {
                return false;
            }

            // Ensure the date is not in the future
            if (date > today) {
                return false;
            }

            return true;
        },
        validateDOBAndContinue() {
            this.formErrors = {};
            const {
                mm,
                dd,
                yyyy
            } = this.people.dob;

            if (!mm || !dd || !yyyy) {
                this.formErrors.dob = 'Please enter a complete date of birth';
                return;
            }

            // Add padding to month and day
            const paddedMonth = String(mm).padStart(2, '0');
            const paddedDay = String(dd).padStart(2, '0');

            if (!this.isValidDate(paddedMonth, paddedDay, yyyy)) {
                this.formErrors.dob = 'Please enter a valid date of birth';
                return;
            }

            this.people.dobMMDDYYYY = `${paddedMonth}/${paddedDay}/${yyyy}`;

            // Calculate age
            const birthDate = new Date(yyyy, paddedMonth - 1, paddedDay);
            const today = new Date();
            let age = today.getFullYear() - birthDate.getFullYear();
            const m = today.getMonth() - birthDate.getMonth();
            if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                age--;
            }
            this.people.age = age;

            this.active_el++;
        },
        calculateBMI() {
            const heightInInches = (parseInt(this.people.height.foot) * 12) + parseInt(this.people.height.inches);
            const weightInPounds = parseInt(this.people.weight);
            this.people.bmi = (weightInPounds / (heightInInches * heightInInches)) * 703;
            this.people.heightInInches = heightInInches;
        },
        updateAgreement(selectedValue) {
            // Toggle the agreement value
            this.people.agreed_to_text = this.people.agreed_to_text === selectedValue ? null : selectedValue;
        },
        updateGender(selectedGender) {
            // Set the gender selection and move to next step
            this.people.gender = selectedGender;
            this.active_el++;
        },
        validateStep1() {
            this.formErrors = {};
            if (!this.people.agreed_to_terms) {
                this.formErrors.terms = 'Please agree to the terms and conditions';
                return false;
            }
            return true;
        },
        validateStep2() {
            this.formErrors = {};
            if (!this.people.state) {
                this.formErrors.state = 'Please select your state';
                return false;
            }

            // Check if state is in disqualified list
            if (["LA", "MS", "AL"].includes(this.people.state)) {
                this.$router.push({
                    name: 'leadDisqualified',
                    query: {
                        message: "Unfortunately, our GLP Medical Weight Loss program is not yet available in your state. However, we're excited to announce that it will be launching next month!"
                    }
                });
                return false;
            }

            return true;
        },
        validateStep3() {
            this.formErrors = {};
            if (!this.people.first_name || !this.people.last_name) {
                this.formErrors.name = 'Please enter your full name';
                return false;
            }
            return true;
        },
        validateStep4() {
            this.formErrors = {};
            if (!this.people.gender) {
                this.formErrors.gender = 'Please select your gender';
                return false;
            }
            return true;
        },
        validateStep5() {
            this.formErrors = {};
            if (!this.isValidEmail) {
                this.formErrors.email = 'Please enter a valid email address';
                return false;
            }
            if (!this.people.agreed_to_email) {
                this.formErrors.emailConsent = 'Please agree to receive email communications';
                return false;
            }
            return true;
        },
        validateStep6() {
            this.formErrors = {};
            if (!this.isValidPhone) {
                this.formErrors.phone = 'Please enter a complete, valid phone number';
                return false;
            }
            return true;
        },
        validateStep7() {
            this.formErrors = {};

            const foot = parseInt(this.people.height.foot);
            const inches = parseInt(this.people.height.inches);
            const weight = parseFloat(this.people.weight);

            if (isNaN(foot) || isNaN(inches) || foot < 4 || foot > 8 || inches < 0 || inches > 11) {
                this.formErrors.height = 'Please enter a valid height';
                return false;
            }

            if (isNaN(weight) || weight < 80 || weight > 700) {
                this.formErrors.weight = 'Please enter a valid weight';
                return false;
            }

            // Calculate height in inches
            this.people.heightInInches = (foot * 12) + inches;
            // Calculate BMI
            this.people.bmi = this.calculatedBMI;

            return true;
        },
        validateStep9() {
            this.formErrors = {};

            const desiredWeight = parseFloat(this.people.desired_weight);
            const currentWeight = parseFloat(this.people.weight);

            if (isNaN(desiredWeight) || desiredWeight < 80 || desiredWeight > 700) {
                this.formErrors.desiredWeight = 'Please enter a valid desired weight';
                return false;
            }

            if (desiredWeight >= currentWeight) {
                this.formErrors.desiredWeight = 'Desired weight should be less than current weight';
                return false;
            }

            return true;
        },

        // Main form handling methods
        handleSubmit() {
            this.formErrors = {};
            let isValid = false;

            switch (this.active_el) {
                case 1:
                    isValid = this.validateStep1();
                    break;
                case 2:
                    isValid = this.validateStep2();
                    break;
                case 3:
                    isValid = this.validateStep3();
                    break;
                case 4:
                    isValid = this.validateStep4();
                    break;
                case 5:
                    isValid = this.validateStep5();
                    break;
                case 6:
                    isValid = this.validateStep6();
                    break;
                case 7:
                    isValid = this.validateStep7();
                    break;
                default:
                    isValid = true;
                    break;
            }

            if (!isValid) {
                return;
            }

            this.active_el++;
        },

        async finalSubmit() {
            if (!this.validateStep9()) {
                return;
            }

            if (this.isSubmitting) {
                return;
            }

            try {
                this.isSubmitting = true;

                // Do age check
                if (this.people.dob.yyyy && parseInt(this.people.dob.yyyy) > 2006) {
                    this.$router.push({
                        name: 'leadDisqualified',
                        query: {
                            message: "We cannot proceed since your age is less than 18 years."
                        }
                    });
                    return false;
                }

                // Calculate BMI one more time to be sure
                this.calculateBMI();
                this.people.phone = this.phoneNumber;
                this.people.user_agent = window.navigator.userAgent;
                if(window.trackingSessionId){
                    this.people.tracking_session_id = window.trackingSessionId;
                }
                // Set the complete data for submission - now this is the only place where we submit data
                const completeData = {
                    ...this.people,
                    is_completed: true
                };

                const response = await this.$axios.post(`${this.baseUrl}/api/intake-form`, completeData, {
                    headers: {
                        'Content-Type': 'application/json',
                        "Access-Control-Allow-Origin": "*"
                    }
                });

                if (response.data.status === 'success') {
                    this.people.id = response.data.user.id;
                    this.$store.dispatch("doLogin", response.data);
                    this.pageStep = 2;
                } else {
                    throw new Error('Failed to submit form');
                }
            } catch (error) {
                console.error('Form submission error:', error);
                this.formErrors.submission = 'There was an error submitting your form. Please try again.';
            } finally {
                this.isSubmitting = false;
            }
        },

        handlePhoneInput(event, field) {
            const value = event.target.value.replace(/\D/g, '');

            if (value.length == 10) {
                const areaCodeLength = 3;
                const prefixLength = 3;
                const lineLength = 4;

                // Extract each part of the phone number based on its defined length
                this.people.phone_parts.areaCode = value.slice(0, areaCodeLength);
                this.people.phone_parts.prefix = value.slice(areaCodeLength, areaCodeLength + prefixLength);
                this.people.phone_parts.line = value.slice(areaCodeLength + prefixLength, areaCodeLength + prefixLength + lineLength);
            }

            const maxLength = {
                areaCode: 3,
                prefix: 3,
                line: 4
            } [field];

            this.people.phone_parts[field] = value.slice(0, maxLength);

            // Auto-focus next field
            if (value.length >= maxLength) {
                const nextField = {
                    areaCode: 'prefix',
                    prefix: 'line'
                } [field];

                if (nextField) {
                    this.$refs[nextField]?.focus();
                }
            }
        },

        handleGenderSelection(gender) {
            this.people.gender = gender;
        }
    }
}
</script>
<style scoped>

input,
select,
textarea,
input[type="text"],
input[type="number"],
input[type="email"],
input[type="password"],
input[type="tel"],
input[type="url"],
input[type="search"] {
  font-size: 18px !important;
}

/* Floating button styles */
.floating-cta-button {
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  width: 25%;
  
  /* Enhanced styling for floating effect */
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border-radius: 50px; /* More rounded for modern floating button look */
  padding: 15px 25px;
  text-align: center;
  
  /* Smooth transitions */
  transition: all 0.3s ease;
}

/* Hover effects */
.floating-cta-button:hover {
  transform: translateX(-50%) translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.25);
}

/* Active state */
.floating-cta-button:active {
  transform: translateX(-50%) translateY(0);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

/* Optional: Add a subtle animation */
@keyframes float {
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-3px); }
}

/* Uncomment to add floating animation */
/*
.floating-cta-button {
  animation: float 3s ease-in-out infinite;
}
*/

/* Responsive adjustments */
@media (max-width: 768px) {
  .floating-cta-button {
    /* Full width at bottom on mobile */
    width: 98%;
    left: 50%;
    right: auto;
    bottom: 15px;
    transform: translateX(-50%);
    padding: 15px 20px;
    border-radius: 12px; /* Less rounded on mobile for better touch target */
    text-align: center;
  }
  
  /* Adjust hover effect for mobile */
  .floating-cta-button:hover {
    transform: translateX(-50%) translateY(-1px);
  }
  
  .floating-cta-button:active {
    transform: translateX(-50%) translateY(0);
  }
}

/* Make sure the button doesn't interfere with page content */
body {
  padding-bottom: 80px; /* Add space at bottom to prevent content overlap */
}
</style>
